var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model.text)?_c('v-col',{attrs:{"slot":"header"},slot:"header"},[(_vm.model.text.listTitle || _vm.title)?_c('div',{class:_vm.titleClass,style:(_vm.titleStyle)},[(_vm.titlePrepend)?[_vm._v(_vm._s(_vm.titlePrepend))]:_vm._e(),_vm._v(" "+_vm._s(_vm.title || _vm.model.text.listTitle)+" ")],2):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }